<template>

  <div v-if="type == 'one_button'" id="add_to_cart">
    <button @click="quantity = quantity - 1" type="button" class="product-form__quantity-button btn" :disabled="disabled || quantity < 2">&minus;</button>
    <button type="submit" name="add" class="product-form__submit btn btn--primary md" data-add-to-cart :disabled="disabled">
      {{ text }}      
    </button>
    <button @click="quantity++" type="button" class="product-form__quantity-button btn" :disabled="disabled">+</button>
    <input type="hidden" name="quantity" :value="`${quantity}`" min="0" pattern="[0-9]*" aria-label="quantity">
  </div>

  <div v-else>
    <div>
      <button @click="quantity = quantity - 1" type="button" class="btn product-form__quantity-button" :disabled="disabled || quantity < 2">&minus;</button>
      <span type="submit" name="add" class="product-form__submit btn" data-add-to-cart :disabled="disabled">
        {{ quantity }}
      </span>
      <button @click="quantity++" type="button" class="btn product-form__quantity-button" :disabled="disabled">+</button>
      <input type="hidden" name="quantity" :value="`${quantity}`" min="0" pattern="[0-9]*" aria-label="quantity">
    </div>
    <button type="submit" name="add" class="product-form__submit btn" data-add-to-cart :disabled="disabled">
      {{ $language.product.add_to_cart }}
    </button>
  </div>

</template>

<script>
export default {
  props: [ 'type', 'available' ],

  data () {
    return {
      quantity: 1,
      sold_out: false
    }
  },

  computed: {
    text () {
      if (this.sold_out || !this.available) return this.$language.product.sold_out
      return `ADD ${ this.quantity } TO CART`
    },
    disabled () {
      return this.sold_out || !this.available
    }
  },

  methods: {
    optionChanged (variant) {
      this.sold_out = !variant.available
    }
  }
}
</script>
